import { MdOutlineCelebration } from "react-icons/md";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";

export default function Step3({ step1Completed, step2Completed }) {
  const openDocs = () => {
    window.open("https://ooval.readme.io/", "_blank");
  };

  const navigateToCreateEvent = () => {
    window.location.href = "/create-event";
  };

  return (
    <div
      className="standard-container"
      style={{
        display: (!step1Completed || !step2Completed) && "none",
      }}
    >
      <h2>You are ready to evolve your ticketing!</h2>
      <p id="subTitle" style={{ marginBottom: "20px" }}>
        Now you can create an event and use the OOVAL APIs!
      </p>
      <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
        <MainButton
          text={"See API documentation"}
          color={COLORS.black}
          hoverColor={COLORS.black}
          textColor={COLORS.white}
          borderColor={COLORS.grey}
          shadowColor={COLORS.mainAccent}
          textHoverColor={COLORS.lightGrey}
          onClickAction={() => openDocs()}
          width={"fit-content"}
        >
          <MdOutlineCelebration size={20} />
        </MainButton>
        <MainButton
          text={"Create event"}
          color={COLORS.black}
          hoverColor={COLORS.black}
          textColor={COLORS.white}
          borderColor={COLORS.grey}
          shadowColor={COLORS.mainAccent}
          textHoverColor={COLORS.lightGrey}
          onClickAction={() => navigateToCreateEvent()}
          width={"fit-content"}
        >
          <MdOutlineCelebration size={20} />
        </MainButton>
      </div>
    </div>
  );
}
